require('./catalog-view-node.component.scss');

class CatalogViewNodeController {
  constructor(
    $q,
    FilterEditorService,
    FilterCardEditorModalService,
    FilterDataFactory,
    PermissionService,
  ) {
    this.$q = $q;
    this.showReport = false;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.filterData = FilterDataFactory();
    this.permission = PermissionService;
  }

  $postLink() {
    this.showReport = this.filter && this.filter.isCatalog;
  }

  get filter() {
    return this._filter;
  }

  set filter(filter) {
    this._filter = filter;
    this.filterData.update(filter);
  }

  toggle() {
    this.showReport = !this.showReport;
  }

  editFilter() {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew : false,
      selectFilter: false,
    });
  }
}

export const CatalogViewNodeComponent = {
  template  : require('./catalog-view-node.component.html'),
  bindings  : {
    model    : '<',
    filter   : '<',
    filterBar: '<',
  },
  controller: CatalogViewNodeController,
};



// WEBPACK FOOTER //
// ./src/view/catalog/catalog-view-node.component.js